<template>
  <div class="search-heroes">
    <h1 class="search-heroes__title page-title">
      Search teammates
    </h1>

    <search-events-form
      @recieve-data="handleRecieveData"
      @reset-data="handleResetData"
      :skip="skip"
      :limit="limit"
      :team-id="teamId"
      ref="searchForm"
    />

    <search-result
      :user-array="userArray"
      :total="total"
      :team-id="teamId"
      @update-data="handleUpdateSearchResult"
    />

    <el-pagination
      v-if="userArray && userArray.length > 0"
      layout="prev, pager, next"
      :total="total"
      hide-on-single-page
      :page-size="limit"
      :current-page="currentPage"
      @current-change="onNavigate"
    />
  </div>
</template>

<script>
import SearchEventsForm from '@/components/searchTeammates/SearchEventsForm.vue';
import SearchResult from '@/components/searchTeammates/SearchResult.vue';

export default {
  name: 'SearchTeammates',
  components: {
    SearchEventsForm,
    SearchResult,
  },
  data() {
    return {
      userArray: null,
      total: null,
      limit: 20,
      currentPage: 1,
    };
  },
  computed: {
    skip() {
      const { currentPage, limit } = this;
      return (currentPage - 1) * limit;
    },
    teamId() {
      return Number(this.$route.query.teamId);
    },
  },
  methods: {
    handleRecieveData(data) {
      this.userArray = data.items;
      this.total = data.totalCount;
    },
    onNavigate(nextPage) {
      this.currentPage = nextPage;
    },
    handleUpdateSearchResult() {
      const { activeSearchType } = this;
      if (this.$refs.searchForm) {
        this.$refs.searchForm.requestSearchTeammates();
      }
    },
    handleResetData() {
      this.userArray = null;
      this.total = null;
    },
  },
};
</script>
